import { showModalFromHtml } from "../../components/modal";
import ajax from "../../components/ajax";
import { showPreloader } from "../../components/preloader";
function init() {
    document.querySelectorAll('.repeat-order')
        .forEach((item) => item.addEventListener('click', onClick));
}
async function onClick(event) {
    event.preventDefault();
    showPreloader();
    ajax('/api/cart/repeat_order', {
        order_id: this.dataset.orderId,
    })
        .then(response => response.json())
        .then((result) => {
        showModalFromHtml(result.html);
        const basketBlock = document.querySelector('.basket_head');
        if (basketBlock) {
            basketBlock.innerHTML = result.basket_block;
        }
    });
}
init();
